// // useTranslate.js
// import { useSelector } from "react-redux";
// import { arr } from "../data/LanguageTranslate";

// export const useTranslate = () => {
//   const language = useSelector((state) => state.language.language);

//   const t = (key) => {
//     if (language == "en") return key;
//     return arr[key] || key;
//   };

//   return { t };
// };


// useTranslate.js
import { useSelector } from "react-redux";
import { translations } from "../data/LanguageTranslate";

export const useTranslate = () => {
  const language = useSelector((state) => state.language.language);

  const t = (key) => {
    if (language === "en") return key;
    return translations[language]?.[key] || key;
  };

  return { t };
};